import { html, TemplateResult } from 'lit';
import { BookingRequest, Dispatcher } from '../../types/booking-request';
import { showStepWhenCurrentIs, stepId, STEP_AVAILABILITY } from '../../types/steps';
import { WPContent } from '../../types/wp-data';
import { stepIntro } from './partials/step-intro';
import { seeSummaryButton } from './partials/see-summary-button';
import { startOfStayInput } from './partials/start-of-stay-input';
import { calendar } from './calendar/calendar';
import { numberOfPersonsSelect } from './partials/number-of-persons-select';
import { numberOfNightsSelect } from './partials/number-of-nights-select';
import { PropertyDataUpdateLatch } from '../../api/get-calendar-data-for-house';
import { staticText } from '../../static-text';

export function stepAvailability(
	state: BookingRequest,
	dispatch: Dispatcher,
	propertyDataUpdateLatch: PropertyDataUpdateLatch,
	assetUrl: string,
	content: WPContent
): TemplateResult {
	if ( !( showStepWhenCurrentIs( STEP_AVAILABILITY, state.currentStep ) ) ) {
		return html``;
	}

	if ( !state.bookingData.houseId ) {
		throw new Error( 'House ID should be known here.' );
	}

	return html`
		<div class="step" id="${stepId( STEP_AVAILABILITY )}">
			<div class="section theme-grey-light">
				<div class="wrapper">
					<div class="double-columns">
						<div class="double-columns__column">
							${stepIntro( content.titleAvailability, content.textAvailability )}
						</div>
					</div>

					<br>
					<br>

					<div class="double-columns">
						<div class="double-columns__column">
							${calendar( state.bookingData, state.property, propertyDataUpdateLatch, dispatch )}
						</div>

						<div class="double-columns__column">
							<div class="availability-overview">
								<div class="form type-f">
									<fieldset class="form__group">
										${startOfStayInput( state.bookingData.startOfStay, state.bookingData.houseId, state.bookingData.weekData, propertyDataUpdateLatch, dispatch, assetUrl, state.bookingData.startOfStayAria, state.bookingData.startOfStayFailure )}

										${numberOfNightsSelect( state.bookingData.startOfStay, state.bookingData.houseId, state.bookingData.numberOfNights, state.bookingData.weekData, dispatch, assetUrl, state.bookingData.numberOfNightsFailure )}

										${numberOfPersonsSelect( state.bookingData.startOfStay, state.bookingData.numberOfPersons, state.bookingData.maxPersons, dispatch, assetUrl, state.bookingData.numberOfPersonsFailure )}
									</fieldset>
								</div>

								<ul
									aria-hidden="true"
									class="availability-legend"
								>
									<li class="availability-legend__item availability-legend__item--available">
										${staticText.available}
									</li>

									<li class="availability-legend__item availability-legend__item--option">
										${staticText.hasOption}
									</li>

									<li class="availability-legend__item availability-legend__item--booked">
										${staticText.isBooked}
									</li>

									<li class="availability-legend__item availability-legend__item--selection">
										${staticText.yourSelection}
									</li>
								</ul>

								${seeSummaryButton( state, dispatch )}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	`;
}
